export const getErrorMessage = (error: any) => {
  // Check for message in various places (axios and old request-promise format)
  return error?.data?.errorMessage || 
         error?.data?.message || 
         error?.data?.error ||
         error?.message ||
         'An unexpected error occurred';
};
